import React from 'react';
import ImportStudioModal from './studio/ImportStudioModal';

/**
 * Import entry point: everyone gets the Import Studio (visual matching board,
 * duplicate preview, overwrite control). The classic ImportCSVModal is kept on
 * disk as a reference implementation but is no longer rendered anywhere.
 * Props are identical — call sites just render <ImportModal .../>.
 */
export default function ImportModal(props) {
  return <ImportStudioModal {...props} />;
}
